<script>
    import {Form} from '../../../../helpers/Form/Form'

    export default {
        name: "MyPromotedCourseItem",
        props: {
            courseprop: {
                type: Object
            },
        },
        data() {
            return {
                course: {},
                form: new Form({}),
                min_promotions_price: 10000,
                open: false,
                actionButton: {
                    text: 'Opzioni corso'
                }
            }
        },
        created() {
            this.course = this.courseprop;
        },
        watch: {
            courseprop: function (newVal, oldVal) {
                this.course = newVal;
            }
        },
        computed: {},
        methods: {
            getMinPromotionsPrice(){
                var self = this;
                self.course.promotions.forEach(function (element) {
                    if(self.min_promotions_price > element.price){
                        self.min_promotions_price = element.price
                    }
                })
                return self.min_promotions_price;
            },
            goToPromotedCoursePage(course){
                return window.open(`/corsi/${course.slug}/avvicinamento`)
            },
            onDisablePromotion(course) {
                var self = this;
                bootbox.confirm({
                    message: "<span class='fw-600'>Sei sicuro di voler terminare questo OrangoPack?</span>" + "<br>" + "<span class='font-14'>Eliminandolo verrà rimosso dai tuoi inviti definitivamente e non sarà più visibile su Orangogo. Potrai sempre ricrearlo quando vuoi.</span>",
                    buttons: {
                        confirm: {
                            label: 'Elimina invito',
                            className: 'btn btn-white'
                        },
                        cancel: {
                            label: 'Annulla',
                            className: 'btn btn-white-secondary'
                        }
                    },
                    callback: function (result) {
                        if (result) {
                            axios({
                                method: 'put',
                                url: `${window.baseUrl}` + '/corsi/' + course.slug + '/update-promotion',
                                data: {
                                    is_promoted: !course.is_promoted
                                }
                            }).then((response) => {
                                course.is_promoted = response.data.is_promoted;
                            }).catch((error) => {
                                self.$emit('init-error', 'Active failed');
                            });
                            /*self.form
                                .submit('put', `${window.baseUrl}/corsi/${course.slug}/update-promotion`)
                                .then((response) => {
                                    course.is_promoted = response.data.is_promoted;
                                    location.reload();
                                }).catch((error) => {
                                self.$emit('init-error', 'Active failed');
                            });*/
                        }
                    },
                })
                $('.modal-dialog').addClass('modal-dialog-centered');
            },
            toggleActions(){
                this.open = !this.open;
                this.actionButton.text = this.open ? 'Chiudi' : 'Opzioni corso';
            },
            isOpen(){
                return this.open;
            },

        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/company/dashboard/partials/MyPromotedCourseItem.vue